<template>
  <div id="app">
    <template>
      <router-view></router-view>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      translationLoaded: false,
    };
  },
  created() {
    this.setLangHtmlTag();
  },
  mounted() {
    this.cleanStorageIfVersionChange();
  },
  methods: {
    setLangHtmlTag() {
      document.documentElement.setAttribute('lang', this.userLang === 'be' ? 'fr' : this.userLang);
    },
    loadTranslations() {
      this.translationService.getTranslations(this.userLang).then(res => {
        this.translationLoaded = true;
      });
    },
    cleanStorageIfVersionChange() {
      const token = localStorage.getItem('version_token');
      if (!token || token !== this.versionToken) {
        localStorage.clear();
        localStorage.setItem('version_token', this.versionToken);
        this.$router.go(null);
      }
    },
  },
  computed: {
    versionToken() {
      return process.env.VUE_APP_DEPLOY_VERSION_TOKEN || '1.2.2';
    },
    userLang() {
      return this.$store.getters['auth/userLang'] || this.$i18n.locale;
    },
  },
  watch: {
    userLang: function() {
      this.loadTranslations();
    },
  },
};
</script>

<style lang="scss">
// @import "assets/base.scss";
@import '../themes/architectui/src/assets/base.scss';
</style>
